import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Menu from "../layouts/Menu";

const RequireAuth = ({ allowedRoles }) => {
	const { auth, authLoading } = useAuth();
	const location = useLocation();
	if (authLoading) {
		return <div className="p-6 text-sm text-slate-500">Restoring session...</div>;
	}
	//return auth?.roles?.find(role => allowedRoles?.includes(role)) ? (
	return auth?.accessToken ? (
		<Menu roles={auth.roles} />
	) : auth?.user ? (
		<Navigate to="/" state={{ from: location }} replace />
	) : (
		<Navigate to="/" state={{ from: location }} replace />
	);
};

export default RequireAuth;
